'use client'

import { ShoppingCart, CreditCard, Package, BarChart3 } from 'lucide-react'
import ServicePageTemplate from '@/components/ServicePageTemplate'

export default function EcommerceDevelopmentPage() {
  return (
    <ServicePageTemplate
      title="eCommerce"
      titleHighlight="Development"
      description="Scalable online stores and marketplaces with advanced features, payment integrations, and inventory management."
      accentColor="from-emerald-500 to-green-600"
      stats={[
        { value: '150+', label: 'Stores Built' },
        { value: '$50M+', label: 'Revenue Generated' },
        { value: '99.9%', label: 'Uptime' },
        { value: '3x', label: 'Avg. Conversion Boost' }
      ]}
      services={[
        { icon: <ShoppingCart className="w-6 h-6" />, title: 'Custom Ecommerce', description: 'Fully custom online stores tailored to your brand.', features: ['Custom Storefronts', 'Multi-Vendor Support', 'Product Catalogs', 'Advanced Search'] },
        { icon: <CreditCard className="w-6 h-6" />, title: 'Payment Integration', description: 'Secure payment gateways and checkout optimization.', features: ['Stripe & PayPal', 'Multi-Currency', 'Subscription Billing', 'PCI Compliance'] },
        { icon: <Package className="w-6 h-6" />, title: 'Inventory Management', description: 'Automated inventory tracking and order fulfillment.', features: ['Stock Management', 'Order Tracking', 'Warehouse Integration', 'Shipping APIs'] },
        { icon: <BarChart3 className="w-6 h-6" />, title: 'Analytics & Growth', description: 'Data-driven insights to boost sales and conversion.', features: ['Sales Analytics', 'Customer Segmentation', 'A/B Testing', 'Marketing Automation'] },
      ]}
      technologies={[
        { name: 'Shopify', category: 'Platform' }, { name: 'WooCommerce', category: 'Platform' },
        { name: 'Magento', category: 'Platform' }, { name: 'Next.js', category: 'Custom' },
        { name: 'Stripe', category: 'Payment' }, { name: 'Algolia', category: 'Search' },
        { name: 'Redis', category: 'Cache' }, { name: 'AWS', category: 'Infrastructure' },
      ]}
      process={[
        { step: '01', title: 'Business Analysis', description: 'Understand your products, audience, and revenue goals.' },
        { step: '02', title: 'UX & Design', description: 'Conversion-focused storefront design and navigation.' },
        { step: '03', title: 'Development', description: 'Build a performant, secure, and scalable store.' },
        { step: '04', title: 'Payment & Shipping', description: 'Integrate payment gateways and logistics providers.' },
        { step: '05', title: 'Testing & Launch', description: 'Load testing, security audit, and go-live.' },
        { step: '06', title: 'Growth & Support', description: 'Ongoing optimization and feature additions.' },
      ]}
    />
  )
}
